//import { skeletonDatasetSection, renderDatasetSection } from "./datasetsTableView.js";
import ServerStatusSectionView from "./ServerStatusSectionView.js"; 
import ServerDatasetsSectionView from "./datasetsTableView.js";
import ServerValidateSectionView from "./ValidateSectionView.js";
import EventAnalyticsSectionView from "./EventAnalyticsSectionView.js";
import {  
  getWaffleStatusForServer,
  getWaffleDatasetConfig,
  getWaffleDatasetInfoForServer,
} from "../_resources/waffle-helpers.js";
import {  
  getSupaACL,
  getSupaServerList,
  getSupaPageDatasourcesForServer,
  getSupaDatasetControlListForServer,
} from "../_resources/supa-helpers.js";
import { sidebarCollapseController } from "../_resources/ui-library.js";
import { getSubtab, setSubtab, backfillSubtab } from "../_resources/url-state.js";

const SELECTED_SERVER = 'admin.servers.selected_server_id';
const SELECTED_SUBPANEL = 'admin.servers.selected_subpanel_id';
const SUBPANELS = ['datasets', 'validate', 'events'];

function getSelectedServer(serverList){
  // Only use localStorage for selected server
  const selectedServerId = localStorage.getItem(SELECTED_SERVER);
  const selectedServer = serverList.find(s => s.id === selectedServerId);
  return selectedServer || serverList[0];
}


const ServersView = function({ dom, message, getToken, getUserId}) {
  const {bad, info, progress, good} = message;
  const container = d3.select(dom);

  sidebarCollapseController(dom);

  const serverStatusSecion = new ServerStatusSectionView({ dom: container.select(".statusSection"), onClickRefresh: () => render(true) });
  const datasetSection = new ServerDatasetsSectionView({ 
    dom: container.select(".contentSection"), 
    refresh: () => render(true), 
    bad, info, progress, good 
  });

  const validateSection = container.append("div").class("validateSection").style("display", "none");
  const validateSectionView = new ServerValidateSectionView({ dom: validateSection, message, getToken });

  const eventsSection = container.append("div").class("eventsSection").style("display", "none");
  const eventsSectionView = new EventAnalyticsSectionView({ dom: eventsSection, message, getToken });

  let currentServer = null;
  let currentDatasets = [];
  let currentServerError = false;

  const navItems = container.select(".admin-sidebar").selectAll(".nav-item");
  navItems.on("click", function(event) {
    const target = d3.select(this).attr("data-route");
    event.preventDefault();
    showSubpanel(target);
    if (currentServerError) {
      if (target === "validate") validateSectionView.renderError("Could not contact server");
      else if (target === "events") eventsSectionView.renderError("Could not contact server");
      else datasetSection.renderError("Could not contact server");
      return;
    }
    if (target === "validate" && currentServer) {
      validateSectionView.render({
        selectedServerUrl: currentServer.url,
        serverDatasets: currentDatasets,
        token: getToken()
      });
    }
    if (target === "events" && currentServer) {
      eventsSectionView.render({ selectedServerUrl: currentServer.url, serverDatasets: currentDatasets });
    }
    if (target === "datasets" && currentServer) {
      onClickCard(currentServer);
    }
  });

  function showSubpanel(subpanelId) {
    // Teardown heavy DOM when leaving the events tab
    if (subpanelId !== "events") eventsSectionView.teardown();
    setSubtab(subpanelId, SELECTED_SUBPANEL);
    navItems.classed("active", function() {
      return d3.select(this).attr("data-route") === subpanelId;
    });
    container.select(".contentSection").style("display", subpanelId === "datasets" ? null : "none");
    validateSection.style("display", subpanelId === "validate" ? null : "none");
    eventsSection.style("display", subpanelId === "events" ? null : "none");
  }


  async function render(refresh = false) {

    const {ok: supaACL, error: e1} = await getSupaACL(refresh);   
    const {ok: serverList, error: e2} = await getSupaServerList(refresh);
    if (e1 || e2) return bad(e1 || e2); //❌
    serverStatusSecion.render(serverList, onClickCard);

    const selectedServer = getSelectedServer(serverList);


    const statusResults = await Promise.allSettled(serverList.map(server => getWaffleStatusForServer(server, refresh)));
    statusResults.forEach(({status, value, reason}, i) => {
      const server = serverList[i];
      const fetchError = status === "rejected" ? reason : value?.error;
      const fetchedStatus = value?.ok ?? null;
      if (fetchError) bad(fetchError); //⚠ log but don't stop
      serverStatusSecion.updateCard(server.id, fetchedStatus, selectedServer.id, selectedServer.url, getToken, getUserId);
    });

    await onClickCard(selectedServer, refresh);
  }

  async function onClickCard(selectedServer, refresh = false) {
      if (selectedServer.id !== localStorage.getItem(SELECTED_SERVER)) {
        localStorage.setItem(SELECTED_SERVER, selectedServer.id);
      }
      currentServer = selectedServer;

      const {ok: datasetConfig, error: e_dc} = await getWaffleDatasetConfig(selectedServer, getToken(), refresh);
      if (e_dc) {
        bad(e_dc); //❌
        currentServerError = true;
        const subpanelId = getSubtab(SELECTED_SUBPANEL, SUBPANELS, "datasets");
        backfillSubtab(subpanelId);
        showSubpanel(subpanelId);
        if (subpanelId === "validate") validateSectionView.renderError("Could not contact server");
        else if (subpanelId === "events") eventsSectionView.renderError("Could not contact server");
        else datasetSection.renderError("Could not contact server");
        return;
      }
      currentServerError = false;
      currentDatasets = datasetConfig?.datasetControlList || [];

      const subpanelId = getSubtab(SELECTED_SUBPANEL, SUBPANELS, "datasets");
      backfillSubtab(subpanelId);
      showSubpanel(subpanelId);

      if (subpanelId === "validate") {
        validateSectionView.render({
          selectedServerUrl: selectedServer.url,
          serverDatasets: currentDatasets,
          token: getToken()
        });
        return;
      }

      if (subpanelId === "events") {
        eventsSectionView.render({ selectedServerUrl: selectedServer.url, serverDatasets: currentDatasets });
        return;
      }

      const {ok: supaACL, error: e1} = await getSupaACL(refresh);
      const {ok: supaPageDatasources, error: e2} = await getSupaPageDatasourcesForServer(selectedServer, refresh);
      const {ok: supaDatasets, error: e3} = await getSupaDatasetControlListForServer(selectedServer, refresh);
      const {ok: datasetInfo, error: e4} = await getWaffleDatasetInfoForServer(selectedServer, getToken(), refresh);
      if (e1 || e2 || e3 || e4) bad(e1 || e2 || e3 || e4); //❌

      datasetSection.render({
        serverDatasetSlugToBranchToCommitMapping: datasetConfig.datasetBranchCommitMapping, 
        commitTimeStamp: datasetConfig.commitTimeStamp,
        commitAuthor: datasetConfig.commitAuthor,
        serverDatasets: currentDatasets, 
        supaDatasets, 
        supaPageDatasources,
        datasetInfo, 
        supaACL, 
        selectedServerId: selectedServer.id, 
        selectedServerUrl: selectedServer.url,
        token: getToken(),
        userId: getUserId()
      });
  }


  return {render};
}
export default ServersView;







